
// WebpackRequireFrom
typeof __webpack_require__ !== "undefined" && Object.defineProperty(__webpack_require__, "p", {
  get: function () {
try {
  if (typeof tms_context_path !== "string") {
    throw new Error("WebpackRequireFrom: 'tms_context_path' is not a string or not available at runtime. See https://github.com/agoldis/webpack-require-from#troubleshooting");
  }
  return tms_context_path;
} catch (e) {
  if (!false) {
    console.error(e);
  }
  return "/";
}
 },
  set: function (newPublicPath) {
    console.warn("WebpackRequireFrom: something is trying to override webpack public path. Ignoring the new value" + newPublicPath  + ".");
}
});